module.exports = __webpack_public_path__ + "static/media/positive.49e9a022.svg";